import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

/**
 * NetworkAlert 모달이 표시되는 동안 검사 타이머를 일시정지한다.
 * 네트워크가 복구되면, 검사가 진행 중이었을 때만 다시 시작한다.
 *
 * 타이머의 start/stop 함수는 useTimer가 Redux `time` 슬라이스에 등록한다.
 * /main 페이지에 진입하기 전에는 no-op 이므로 안전하다.
 */
export const useNetworkPauseTimer = () => {
  const networkState = useSelector((state) => state.networkState) || {};
  const time = useSelector((state) => state.time);
  const userState = useSelector((state) => state.userState);

  const wasPausedByNetwork = useRef(false);

  const { browserOnline, socketStatus } = networkState;
  const isNetworkBlocking =
    !browserOnline ||
    socketStatus === "loading" ||
    socketStatus === "disconnected" ||
    socketStatus === "connect_error" ||
    socketStatus === "reconnecting" ||
    socketStatus === "reconnect_failed";

  useEffect(() => {
    if (isNetworkBlocking) {
      if (typeof time?.stop === "function" && !wasPausedByNetwork.current) {
        time.stop();
        wasPausedByNetwork.current = true;
      }
      return;
    }

    if (wasPausedByNetwork.current) {
      if (userState?.check && typeof time?.start === "function") {
        time.start();
      }
      wasPausedByNetwork.current = false;
    }
  }, [isNetworkBlocking, userState?.check, time]);
};
